import { helloTradeClient } from "../api/axiosClient";
import { HT_ENDPOINTS } from "../api/endpoints";

export async function checkConsent(glid, ak) {
  try {
    const data = await helloTradeClient.get(HT_ENDPOINTS.CHECK_CONSENT, {
      params: { glid, ak },
      timeout: 8000,
    });
    return data?.data ?? data;
  } catch (error) {
    console.error("checkConsent failed:", error);
    return null;
  }
}

export async function createConsent({ glid, ak }) {
  try {
    const data = await helloTradeClient.post(
      HT_ENDPOINTS.CREATE_CONSENT,
      { glid, ak },
      { headers: { "Content-Type": "application/json" }, timeout: 8000 }
    );
    return data?.data ?? data;
  } catch (error) {
    console.error("createConsent failed:", error);
    return null;
  }
}
